module.exports = "/_next/static/images/OgConnections-35ef2b1ea1410ef0d20b40297d500460.png";